import React, { useEffect, useRef } from 'react';

// Handle cases where nav type changes (and so GWTInjectPoint gets unrendered/rerendered)
let previousContent;

function GWTInjectPoint() {
  const contentRef = useRef();

  useEffect(() => {
    const { current: currentContent } = contentRef;
    if (window.XM_INJECT_GWT) {
      window.XM_INJECT_GWT();
    } else {
      window.XM_REACT_READY_INJECT_GWT_YOURSELF = true; // Die, race condition, die!
    }

    const cocoonPage = document.getElementById('cocoon-page-view');
    if (cocoonPage) {
      cocoonPage.id = 'page-view';
      currentContent.innerHTML = '';
      currentContent.appendChild(cocoonPage);
      cocoonPage.setAttribute('style', 'display:block;');
    } else if (previousContent) {
      for (let i = 0; i < previousContent.length; i += 1) {
        currentContent.appendChild(...previousContent);
      }
    }

    return () => {
      previousContent = currentContent.childNodes;
    };
  });

  return <div id="GWTInjectPoint" ref={contentRef} />;
}

export default GWTInjectPoint;
